import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import { Box, Button, Typography } from '@mui/material';
import { observer } from 'mobx-react';
import React from 'react';

import { TranslateText } from '../../../../../../../../../application/language/TranslateText';
import { Colors } from '../../../../../../../../design/color/Colors';
import { IUnitListAdminCard } from '../../../../interface/IUnitListAdminCard';

export interface IUnitListAdminCardProperties {
  card: IUnitListAdminCard;
  handleEdit: any;
  handlePublish: any;
  handleUnpublish: any;
  handleDelete: any;
  handleCheck: any;
  isChecked?: boolean;
}
export const RecommendedUnitListItem = observer(
  ({ card, handleEdit, handleCheck, isChecked }: IUnitListAdminCardProperties) => {
    const onItemChecked = (e) => {
      e.stopPropagation();
      handleCheck(card.id);
    };

    return (
      <Box
        sx={{
          cursor: 'pointer',
          padding: '8px 16px',
          display: 'flex',
          justifyContent: 'space-between',
          background: Colors.bgInput,
          alignItems: 'center',
          width: '100%',
          borderRadius: '8px',
          '&:hover': {
            background: Colors.bgSurface,
          },
        }}
        onClick={() => handleEdit(card.id)}
      >
        <Typography sx={{ cursor: 'pointer', flex: 1, minWidth: 0 }}>{card.name}</Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}>
          <Button onClick={onItemChecked} sx={{ textTransform: 'uppercase', display: 'flex', alignItems: 'center', gap: '4px', whiteSpace: 'nowrap' }}>
            {!isChecked && <span>Добавить</span>}
            {isChecked ? <StarIcon /> : <StarBorderIcon />}
          </Button>
        </Box>
      </Box>
    );
  },
);
